import { KomboSettingsPanel } from '@/modules/kombo';

/**
 * ATS settings — currently surfaces the Kombo connector marketplace. Same
 * page for everyone; the Kombo "Connect" CTA is hardcoded disabled until
 * the integration is provisioned, so Members see the marketplace but can't
 * activate connections.
 */
export function AtsPage() {
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">ATS</h1>
        <p className="text-sm text-gray-500 mt-1">
          Connect an external ATS to sync roles, candidates, and pipeline stages.
        </p>
      </header>
      <KomboSettingsPanel />
    </div>
  );
}
